import * as types from '../actiontypes';

export function setIsModalOpen(isModalOpen) {
	return {
		type: types.SET_IS_MODAL_OPEN,
		isModalOpen
	};
}

export function setModalLevel(modalLevel) {
	return {
		type: types.SET_MODAL_LEVEL,
		modalLevel
	};
}

export function setIsADCModalOpen(isADCModalOpen) {
	return {
		type: types.SET_IS_ADC_MODAL_OPEN,
		isADCModalOpen
	};
}
